import {RteMethodProps} from '@/rte';
import mentionCache, {IMentionItem} from './mentionCache';

export function getIncrementMentionUserList(editor: RteMethodProps) {
    let docMentions: any = [];
    let commentMentions: any = [];
    try {
        docMentions = editor ? editor.getMentionList() : [];
        commentMentions = editor ? editor.getCommentMentionList() : [];
    } catch (err) {
        console.error(err);

        docMentions = [];
        commentMentions = [];
    }

    const mentions = [...docMentions, ...commentMentions];
    const increment: IMentionItem[] = [];
    mentions.forEach((item: any) => {
        const data = mentionCache.get(item.uuid);
        if (data) {
            increment.push(data);
        }
    });

    return increment;
}
